import * as Styled from './VideoPlaceholder.styled';
import { PlayCircleContainer, VideoPlaceholderContainer } from './VideoPlaceholder.styled';
import { StyledContentContainer } from '../../../containers/StyledContentContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Placeholder that shows when Video Block `src` is not recognized to be of a valid pattern
 */
export const VideoPlaceholder = ({
  alt,
  fit,
  parentLayoutInfo
}) => /*#__PURE__*/_jsx(StyledContentContainer, {
  fit: fit,
  parentLayoutInfo: parentLayoutInfo,
  role: "img",
  "aria-label": alt,
  children: /*#__PURE__*/_jsx(VideoPlaceholderContainer, {
    children: /*#__PURE__*/_jsx(PlayCircleContainer, {
      children: /*#__PURE__*/_jsx(Styled.PlayCircleSvg, {
        height: 33.33,
        width: 33.33
      })
    })
  })
});